module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/perfiles/perfiles.component.css
// module id = ./src/app/components/perfiles/perfiles.component.css
// module chunks = main